import $ from 'jquery';

export default function() {
	$('body').on('ARTICLE_LIST_RENDERED_OR_UPDATED', function() {
		$('li.article').each(function(index, item) {
			var $item = $(item);
			if ($item.data('borderProcessed') == '1') {
			} else {
				$('.dotted-border', $item).css({
					height: ($item.outerHeight() - $('ul.info', $item).outerHeight()) + 'px'
				}).fadeIn();
				$item.data('borderProcessed', '1');
			}

		});
	});
};


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/ArticlesDottedBorder.js